import React, { PropsWithChildren } from 'react'
import { QuickLinks as QuickLinksBase } from '../../../components/QuickLinksProductListing/QuickLinks'

export type QuickLinksProps = {
  data: {
    id: string
    qLinkText: string
    qLinkIcon: {
        icon: string
        variant?: 'legacy' | 'line' | 'monotone' | 'dualtone'
    }
    qLinkIconUrl?: {
      url: string
      target?: string
    }
  }[]
}

export const QuickLinks: React.FC<PropsWithChildren<QuickLinksProps>> = ({ data }) => {
  return (
    <QuickLinksBase justifyContent={data.length > 2 ? 'space-between' : 'flex-start'}>
      {data.map((item, index) => (
        <QuickLinksBase
          key={item.id ?? index}
          card
          iconCode={item.qLinkIcon?.icon}
          title={item.qLinkText}
          href={item.qLinkIconUrl?.url ?? '#'}
          md={2}
          xs={12}
          target={item.qLinkIconUrl?.target === '_blank' ? '_blank' : '_self'}
          variant={item.qLinkIcon?.variant === 'legacy' ? 'monotone' : item.qLinkIcon?.variant}
        />
      ))}
    </QuickLinksBase>
  )
}
